import { FormHelperText } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.error.main,
}));

export default function HelperText(props) {
  return <StyledFormHelperText>{props.children}</StyledFormHelperText>;
}
